// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bmpui-layout-max-width-1200 {\n\twidth: 100%;\n}", "",{"version":3,"sources":["webpack://./src/components/home/main-content-player/thumbnail-player/style.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ","sourcesContent":[".bmpui-layout-max-width-1200 {\n\twidth: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
